module.exports = __webpack_public_path__ + "img/icon-dapps-mew.b96afc77.svg";